import React from "react";
import "./warning-confirmation-popup.scss";
import { WarningConfirmationPopupProps } from "./warning-confirmation-props";
import alertIcon from "../../../assets/icons/dlinkIcon.svg";

/** Warning-styled confirmation popup with customizable texts and icon. */
const WarningConfirmationPopup: React.FC<WarningConfirmationPopupProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Warning!",
  description = "This action may have consequences. Are you sure?",
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  icon,
  isSingleButton = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="warning-popup-overlay">
      <div className="warning-popup">
        <div className="warning-popup-image">
          <div className="alertIcon-background">
            <img src={icon || alertIcon} alt="alert-icon" />
          </div>
        </div>
        <h4 className="warning-title">{title}</h4>
        <p className="warning-message">{description}</p>
        <div className="warning-buttons">
          {isSingleButton ? "" :
          <button className="cancel-button" onClick={onClose}>
            {cancelButtonText}
          </button>}
          <button className="warning-button confirm" onClick={onConfirm}>
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningConfirmationPopup;
